/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from "react";
import ImportantInfo from "../../../atoms/important-updates";
import FuelDeliveryHistory from "../history-delivery";
import FuelRequestHistory from "../history-request";
import CreateOperator from "../operator-register";
import FuelForecast from "../forcast";
import Navbar from "../../../atoms/navbar";
import Footer from "../../../atoms/footer";

import { requestToken } from "../../../auth/AuthServices";
import { Tabs, Alert } from "antd";
import Setting from "../settings";

import { fuel_service } from "../../../config/api.config";
import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";

const FuelMenu = () => {

  const tabKeys = ["1", "2", "3", "4", "5"];
  const initialActiveTab = localStorage.getItem("activeTab") || "1";
  const storedFuelType = localStorage.getItem("fuelTypeFilter");
  const initialFuelType = storedFuelType ? storedFuelType : null;
  const [activeTab, setActiveTab] = useState(initialActiveTab);
  const [fuelType, setFuelType] = useState(initialFuelType);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const fuelTypeOptions = [
    { value: "Solar", label: "Solar" },
    { value: "Benzine", label: "Bensin" },
  ];

  // Ref untuk menyimpan posisi sentuhan
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const SWIPE_THRESHOLD = 200; // Geseran minimum agar dianggap swipe tab

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const deltaX = touchEndX.current - touchStartX.current;

    const currentIndex = tabKeys.indexOf(activeTab);

    // Geser ke kanan (tab sebelumnya)
    if (deltaX > SWIPE_THRESHOLD && currentIndex > 0) {
      setActiveTab(tabKeys[currentIndex - 1]);
    }

    // Geser ke kiri (tab berikutnya)
    if (deltaX < -SWIPE_THRESHOLD && currentIndex < tabKeys.length - 1) {
      setActiveTab(tabKeys[currentIndex + 1]);
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handleFuelTypeChange = (value) => {
    const next = value || null;
    setFuelType(next);

    if (next) {
      localStorage.setItem("fuelTypeFilter", next);
    } else {
      localStorage.removeItem("fuelTypeFilter");
    }
  };

  async function RequestToken() {
    const token = await requestToken();
    if (token) {
      preloadDataForCache(token);
    }
  }

  // Pre-load data for PWA cache in the background
  const preloadDataForCache = async (accessToken) => {

    setIsDataLoaded(false); // Reset loading state

    try {
      console.log("Preloading master data for PWA cache...");

      const requiredUrls = [
        `${fuel_service.endpoint}/api/storage-tanks`,
        `${fuel_service.endpoint}/api/tanker-vehicles`,
        `${fuel_service.endpoint}/api/job-locations`,
        `${fuel_service.endpoint}/api/operator`,
        `${fuel_service.endpoint}/api/request/organization`,
        `${fuel_service.endpoint}/api/equipment-activities`,
        `${fuel_service.endpoint}/api/equipment`,
      ];

      // Check if all required data is already in cache
      const cache = await caches.open('api-cache');
      let cacheKeys = await cache.keys();
      let cachedUrls = cacheKeys.map(req => req.url);
      const allCached = requiredUrls.every(url => cachedUrls.includes(url));

      if (!allCached) {

        console.log("Data not fully cached, fetching from network...");

        const [
          resTank,
          resVehicle,
          resJobLocation,
          resOperators,
          resOrganization,
          resEquipmentActivity,
          resEquipments
        ] = await Promise.all([
          API.StorageTank(HeaderFarms(accessToken), null),
          API.TankerVehicle(HeaderFarms(accessToken), null),
          API.JobLocation(HeaderFarms(accessToken), null),
          API.Operators(HeaderFarms(accessToken), null),
          API.Organization(HeaderFarms(accessToken), null),
          API.EquipmentActivity(HeaderFarms(accessToken), null),
          API.Equipments(HeaderFarms(accessToken), null),
        ]);

        // Verify data is cached by checking if responses have data
        const hasTankData = resTank.data && resTank.data.length > 0;
        const hasVehicleData = resVehicle.data && resVehicle.data.length > 0;
        const hasJobLocationData = resJobLocation.data && resJobLocation.data.length > 0;
        const hasOperatorsData = resOperators.data && resOperators.data.length > 0;
        const hasOrganizationData = resOrganization.data && resOrganization.data.length > 0;
        const hasEquipmentActivityData = resEquipmentActivity.data && resEquipmentActivity.data.length > 0;
        const hasEquipmentsData = resEquipments.data && resEquipments.data.length > 0;

        if (!hasTankData || !hasVehicleData || !hasJobLocationData || !hasOperatorsData ||
            !hasOrganizationData || !hasEquipmentActivityData || !hasEquipmentsData) {
          throw new Error("Some master data failed to load");
        }

        // Wait a bit for service worker to cache
        await new Promise(resolve => setTimeout(resolve, 500));

        // Re-check cache after fetch
        cacheKeys = await cache.keys();
        cachedUrls = cacheKeys.map(req => req.url);
        const nowAllCached = requiredUrls.every(url => cachedUrls.includes(url));

        if (!nowAllCached) {
          console.warn("⚠️ Some data not yet in cache, retrying...");
          await new Promise(resolve => setTimeout(resolve, 1000));
          cacheKeys = await cache.keys();
          cachedUrls = cacheKeys.map(req => req.url);
          if (!requiredUrls.every(url => cachedUrls.includes(url))) {
            throw new Error("Failed to cache all required data");
          }
        }

        const tanks = resTank.data || [];
        const vehicles = resVehicle.data || [];
        const allDistribution = [...vehicles, ...tanks];
          
        console.log(`Pre-caching CalculateIssuedPeriod for ${allDistribution.length} distribution points.`);

        // Wait for all CalculateIssuedPeriod to be cached
        await Promise.allSettled(
          allDistribution
            .map(item => {
              // Create a combined key: use tank_code if available, otherwise use vehicle_number.
              item.combine = item.tank_code || item.vehicle_number;
              return item;
            })
            .filter(item => item.combine) // Ensure we only process items that have a key.
            .map(item => {
              return API.CalculateIssuedPeriod(HeaderFarms(accessToken), { receiveID: item.combine })
                .catch(e => console.error(`Failed to pre-cache for ${item.combine}:`, e));
            })
        );

        console.log("All fuel system master data preloaded and cached successfully.");
      } else {
        console.log("All required data already cached.");
      }

      setIsDataLoaded(true);

    } catch (error) {
      console.error("Failesd to preload master data for cache:", error);
      setIsDataLoaded(false); // Ensure loading state is reset on error
    }
  };

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
    RequestToken();
  }, [activeTab]);

  return (
    <>
      <Navbar
        title="Fuel Menu"
        back={true}
        subtitle="Fuel System"
        navigate="/home"
      />
      <div className="container-fluid white-back-cr">
        <ImportantInfo />
        <div style={{ margin: "15px 15px", fontSize: "12px" }}>
          {isDataLoaded ? (
            <Alert
              message={`Siap Pengimputan Offline / Mode Pesawat`}
              type="success"
              showIcon
              closable
              style={{ fontSize: "12px" }}
            />
          ) : (
            <Alert
              message="Memuat Data Sistem Bahan Bakar..."
              type="warning"
              showIcon
              style={{ fontSize: "12px" }}
            />
          )}
        </div>

        <div
          className="container-fluid mt-3"
          style={{ alignSelf: "center" }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <Tabs
            animated
            type="card"
            tabPosition="top"
            size="large"
            activeKey={activeTab}
            onChange={handleTabChange}
          >
            <Tabs.TabPane forceRender tab="Fuel Issued" key="1">
              <FuelRequestHistory
                fuelType={fuelType}
                fuelTypeOptions={fuelTypeOptions}
                onFuelTypeChange={handleFuelTypeChange}
              />
            </Tabs.TabPane>
            <Tabs.TabPane forceRender tab="Fuel Delivery" key="2">
              <FuelDeliveryHistory
                fuelType={fuelType}
                fuelTypeOptions={fuelTypeOptions}
                onFuelTypeChange={handleFuelTypeChange}
              />
            </Tabs.TabPane>
            <Tabs.TabPane forceRender tab="Fuel Forecast" key="3">
              <FuelForecast />
            </Tabs.TabPane>
            <Tabs.TabPane forceRender tab="Register Operator" key="4">
              <CreateOperator />
            </Tabs.TabPane>
            <Tabs.TabPane forceRender tab="Settings" key="5">
              <Setting />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FuelMenu;
